import React from 'react';
import { Loader } from './Loader';
import './styles/Loader.css';

const FullScreenLoader: React.FC = () => {
  return (
    <div className="fullscreen-loader">
      <div className='glass-ui'>
        <Loader />
      </div>
    </div>
  );
};

export default FullScreenLoader;